'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _NoDataTwoTone = require('./lib/icons/NoDataTwoTone');
  
  
  var _default = _NoDataTwoTone;
  exports.default = _default;
  module.exports = _default;